import { Model } from "@bryntum/schedulerpro";
import { HasProjectMixin } from "./mixins/HasProjectMixin";

export const PROMOTE_CARD_TYPES = {
  ROLE: "role",
  DOMAIN_CONTEXT: "domain_context",
  DECLARED_INTENTS: "declared_intents",
  TAGGING_PHILOSOPHY: "tagging_philosophy",
  FOLDER_SUGGESTION_LOGIC: "folder_suggestion_logic",
  TEMPORAL_CLASSIFICATION: "temporal_classification",
  TAGGING_RULES_AND_RESTRAINT: "tagging_rules_and_restraint",
  RESTRICTION_AND_VISIBILITY_RULES: "restriction_and_visibility_rules",
  EDITORIAL_OUTPUT_RULES: "editorial_output_rules",
} as const;

export type PromoteCardTypeValue = (typeof PROMOTE_CARD_TYPES)[keyof typeof PROMOTE_CARD_TYPES];

export class PromotePromptCard extends HasProjectMixin(Model) {

  declare id: number;
  declare board: number;
  declare cardType: PromoteCardTypeValue;
  declare content: string | null;
  declare isEnabled: boolean;
  declare isDraft: boolean;
  declare isDefault: boolean;
  declare createdAt: Date;
  declare updatedAt: Date;
  declare creator: number | null;
  declare updater: number | null;

  static get $name() {
    return "PromotePromptCard";
  }

  static get fields() {
    return [
      "id",
      "board",
      { name: "cardType", dataSource: "card_type" },
      "content",
      { name: "isEnabled", dataSource: "is_enabled", type: "boolean", defaultValue: true },
      { name: "isDraft", dataSource: "is_draft", type: "boolean", defaultValue: false },
      { name: "isDefault", dataSource: "is_default", type: "boolean", defaultValue: true },
      { name: "createdAt", dataSource: "created_at", type: "date" },
      { name: "updatedAt", dataSource: "updated_at", type: "date" },
      { name: "creator", type: "number" },
      { name: "updater", type: "number" },
    ];
  }
}

// @ts-expect-error - exposeProperties is internal method
PromotePromptCard.exposeProperties();
